import React, { useState } from 'react';
import '../styles/AndersProductenPage.css';
import FeedbackModal from '../components/FeedbackModal';

function createEmptyLine() {
  return {
    id: Date.now() + Math.random(),
    omschrijving: '',
    hoeveelheid: ''
  };
}

function AndersProductenPage({ vrijeRegels, onSave, onBack, onLogout, saveLabel = 'Toevoegen aan bestelling' }) {
  const [lines, setLines] = useState(
    vrijeRegels.length > 0
      ? vrijeRegels.map((regel, index) => ({
          id: regel.id || index,
          omschrijving: regel.omschrijving || regel.tekst || '',
          hoeveelheid: regel.hoeveelheid
        }))
      : [createEmptyLine()]
  );
  const [validationError, setValidationError] = useState('');
  const [confirmLeave, setConfirmLeave] = useState(false);

  const isFormDirty = () =>
    lines.some(
      (line) => line.omschrijving.trim() !== '' || (parseInt(line.hoeveelheid, 10) || 0) > 0
    );

  const handleBackClick = () => {
    if (isFormDirty()) {
      setConfirmLeave(true);
      return;
    }
    onBack();
  };

  const handleLineChange = (lineId, field, value) => {
    setValidationError('');
    setLines(
      lines.map((line) => {
        if (line.id !== lineId) return line;
        return {
          ...line,
          [field]:
            field === 'hoeveelheid'
              ? value === ''
                ? ''
                : parseInt(value, 10) || 0
              : value
        };
      })
    );
  };

  const handleAddLine = () => {
    setLines([...lines, createEmptyLine()]);
  };

  const handleRemoveLine = (lineId) => {
    if (lines.length === 1) {
      setLines([createEmptyLine()]);
      return;
    }
    setLines(lines.filter((line) => line.id !== lineId));
  };

  const handleSave = () => {
    const validLines = lines
      .map(({ omschrijving, hoeveelheid }) => ({
        omschrijving: omschrijving.trim(),
        hoeveelheid: parseInt(hoeveelheid, 10) || 0
      }))
      .filter((line) => line.omschrijving !== '' && line.hoeveelheid > 0);

    if (validLines.length === 0) {
      setValidationError('Vul minimaal één product in met een omschrijving en hoeveelheid groter dan 0');
      return;
    }

    onSave(validLines);
    onBack();
  };

  return (
    <div className="anders-producten-container">
      {confirmLeave && (
        <FeedbackModal
          title="Wijzigingen annuleren?"
          message="Je ingevulde producten worden niet opgeslagen. Weet je zeker dat je wilt teruggaan?"
          onConfirm={() => {
            setConfirmLeave(false);
            onBack();
          }}
          onCancel={() => setConfirmLeave(false)}
          confirmLabel="Ja, terug"
          cancelLabel="Nee, blijven"
        />
      )}

      <header className="bestelling-header">
        <button type="button" onClick={handleBackClick} className="back-button">
          ← Terug
        </button>
        <h1>Anders - Vrije producten</h1>
        <button type="button" onClick={onLogout} className="logout-button">
          Uitloggen
        </button>
      </header>

      <main className="bestelling-main">
        <div className="anders-form">
          <p className="anders-intro">
            Vul hier producten in die niet in de standaard lijst staan. Je kunt meerdere regels toevoegen.
          </p>

          {validationError && (
            <div className="error-message" role="alert">
              {validationError}
            </div>
          )}

          <div className="anders-lines">
            {lines.map((line, index) => (
              <div key={line.id} className="anders-line">
                <div className="anders-line-fields">
                  <input
                    type="text"
                    value={line.omschrijving}
                    onChange={(e) => handleLineChange(line.id, 'omschrijving', e.target.value)}
                    placeholder="Productomschrijving"
                    className="anders-text-input"
                    maxLength={255}
                  />
                  <input
                    type="number"
                    min="0"
                    value={line.hoeveelheid}
                    onChange={(e) => handleLineChange(line.id, 'hoeveelheid', e.target.value)}
                    placeholder="0"
                    className="anders-quantity-input"
                  />
                </div>

                {lines.length > 1 && (
                  <button
                    type="button"
                    className="anders-remove-button"
                    onClick={() => handleRemoveLine(line.id)}
                    title="Regel verwijderen"
                  >
                    ✕
                  </button>
                )}

                {index === lines.length - 1 && (
                  <button
                    type="button"
                    className="anders-add-button"
                    onClick={handleAddLine}
                    title="Nieuwe regel toevoegen"
                  >
                    +
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="anders-actions">
            <button type="button" className="submit-button" onClick={handleSave}>
              {saveLabel}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AndersProductenPage;
